const translations = {
    en: {
      register: {
        firstName: "First Name",
        enterFirstName: "Enter first name",
        lastName: "Last Name",
        enterLastName: "Enter last name",
        enterEmail: "Enter email",
        phone: "Phone number",
        enterPhone: "Enter phone number",
        address: "Address",
        enterAddress: "Enter address",
        password: "Password",
        confirmPassword: "Confirm password",
        submit: "Sign up",
      },
      header: {
        myAccount: "My Account",
        aboutUs: "About us",
        ourLeaders: "Our Leaders",
        projects: "Projects",
        contactUs: "Contact us",
        language: "English",
      },
    },
    fr: {
      register: {
        firstName: "Prénom",
        enterFirstName: "Entrez votre prénom",
        lastName: "Nom",
        enterLastName: "Entrez votre nom",
        enterEmail: "Entrez votre email",
        phone: "Numéro de téléphone",
        enterPhone: "Entrez votre numéro de téléphone",
        address: "Adresse",
        enterAddress: "Entrez votre adresse",
        password: "Mot de passe",
        confirmPassword: "Confirmez le mot de passe",
        submit: "S'inscrire",
      },
      header: {
        myAccount: "Mon compte",
        aboutUs: "À propos de nous",
        ourLeaders: "Nos Leaders",
        projects: "Projets",
        contactUs: "Contactez-nous",
        language: "Français",
      },
    },
    
  };
  
  export default translations;
  